import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";

@Component({
  selector: 'app-relation-confirmation',
  templateUrl: './relation-confirmation.component.html',
  styleUrls: []
})
export class RelationConfirmationComponent implements OnInit {

  @HostListener('document:keydown', ['$event']) public onKeyDown($event: KeyboardEvent) {
    $event.stopPropagation();
    if ($event.key === 'Enter') {
      this.handleSubmit()
    }
  }

  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  action_type: string
  item: ListItem
  constructor() { }

  ngOnInit(): void {
    this.action_type = this.payload['action_type'];
    this.item = this.payload['item'];
  }

  public onNoClick(): void {
    this.close.emit()
  }

  public handleSubmit(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }

    this.success.emit()
  }

}
